// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RQks","signatureBlock":"Footer_signatureBlock__ehgQ-","signature":"Footer_signature__jtDHa"};